import React, { useEffect, useState } from 'react';
import { newsApi, News as NewsType, getImageUrl } from '../services/api';
import './News.css';

const News: React.FC = () => {
  const [news, setNews] = useState<NewsType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const response = await newsApi.getAll(true);
      setNews(response.data);
    } catch (error) {
      console.error('Error fetching news:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="news-page">
      <div className="page-header">
        <h1>News & Updates</h1>
        <p>Stay updated with the latest news from Upwork Sdn. Bhd.</p>
      </div>

      <div className="container">
        {loading ? (
          <div className="loading">Loading news...</div>
        ) : news.length > 0 ? (
          <div className="news-list">
            {news.map((item) => (
              <article key={item.id} className="news-article">
                {item.imageUrl && (
                  <div className="news-image">
                    <img src={getImageUrl(item.imageUrl)} alt={item.title} />
                  </div>
                )}
                <div className="news-details">
                  <div className="news-meta">
                    <span className="news-date">
                      {item.publishTime && new Date(item.publishTime).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </span>
                  </div>
                  <h2>{item.title}</h2>
                  <div className="news-content">
                    {item.content.split('\n').map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="no-news">
            <p>No news available at the moment. Please check back later.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default News;
